const Cell = ({ text, className, setHovering, onClick }) => {
  return (
    <div
      onMouseOver={() => setHovering(true)}
      onMouseOut={() => setHovering(false)}
      className={`bg-white font-chinese text-custom-gray p-2 h-full
      whitespace-nowrap overflow-auto cursor-pointer ${className}`}
      onClick={onClick}
    >
      {text ?? ""}
    </div>
  );
};

export default Cell;
